import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CategoryState } from "./category.type";
import { Category } from "@app/types";

const initialState: CategoryState = {
  list: [],
  errorMessage: "",
};

const categorySlice = createSlice({
  name: "@categories",
  initialState,
  reducers: {
    storeCategories(state, action: PayloadAction<Category[]>) {
      state.list = action.payload;
    },
    setCategoryErrorMessage(state, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    clearCategories: () => initialState,
  },
});

export const { storeCategories, clearCategories, setCategoryErrorMessage } =
  categorySlice.actions;

export default categorySlice.reducer;
